const makePositiveNumber = (val) => {
    return (typeof val === 'number' && val < 0) ? -val : val
}

export default makePositiveNumber